__turbopack_context__.v({
  "container": "GiveWellStamp-module-scss-module__BByNHW__container",
  "context": "GiveWellStamp-module-scss-module__BByNHW__context",
  "logo": "GiveWellStamp-module-scss-module__BByNHW__logo",
  "quote": "GiveWellStamp-module-scss-module__BByNHW__quote",
  "stamp": "GiveWellStamp-module-scss-module__BByNHW__stamp",
});
